"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVaccinationDoseOnlyDateDto = instanceOfVaccinationDoseOnlyDateDto;
exports.VaccinationDoseOnlyDateDtoFromJSON = VaccinationDoseOnlyDateDtoFromJSON;
exports.VaccinationDoseOnlyDateDtoFromJSONTyped = VaccinationDoseOnlyDateDtoFromJSONTyped;
exports.VaccinationDoseOnlyDateDtoToJSON = VaccinationDoseOnlyDateDtoToJSON;
exports.VaccinationDoseOnlyDateDtoToJSONTyped = VaccinationDoseOnlyDateDtoToJSONTyped;
/**
 * Check if a given object implements the VaccinationDoseOnlyDateDto interface.
 */
function instanceOfVaccinationDoseOnlyDateDto(value) {
    if (!('dateAdministered' in value) || value['dateAdministered'] === undefined)
        return false;
    return true;
}
function VaccinationDoseOnlyDateDtoFromJSON(json) {
    return VaccinationDoseOnlyDateDtoFromJSONTyped(json, false);
}
function VaccinationDoseOnlyDateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'dateAdministered': json['dateAdministered'],
    };
}
function VaccinationDoseOnlyDateDtoToJSON(json) {
    return VaccinationDoseOnlyDateDtoToJSONTyped(json, false);
}
function VaccinationDoseOnlyDateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'dateAdministered': value['dateAdministered'],
    };
}
//# sourceMappingURL=VaccinationDoseOnlyDateDto.js.map